let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7VPUr")).then(() => parcelRequire('1ZA37'));